import { notify } from '@/shared/ui/ui-notification'
import { type ClassValue, clsx } from 'clsx'

import { storage } from '../storage'

export const cn = (...inputs: ClassValue[]) => {
  return clsx(inputs)
}
export const trimData = (data: unknown): unknown => {
  if (data == null) return data // null hoặc undefined

  if (typeof data === 'string') {
    return data.trim()
  }

  if (Array.isArray(data)) {
    return data.map(trimData)
  }

  if (typeof data === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(data)) {
      result[key] = trimData(val)
    }
    return result
  }

  return data
}

type ConstantItem = {
  value: string | number
  label: string
  technicalRequirement1Text?: string
  technicalRequirement2Text?: string
  sampleDimension1Text?: string
  sampleDimension2Text?: string
  labRemarkText?: string
}
export function getLabelFromConstant(
  constants: Record<string, ConstantItem>,
  value: string | number,
  type?: string
): any {
  const match = Object.values(constants).find((item) => item.value.toString() === value.toString())

  switch (type) {
    case 'label':
      return match?.label ?? value.toString()

    case 'technicalRequirement1Text':
      return match?.technicalRequirement1Text ?? value.toString()

    case 'technicalRequirement2Text':
      return match?.technicalRequirement2Text ?? value.toString()

    case 'sampleDimension1Text':
      return match?.sampleDimension1Text ?? value.toString()

    case 'sampleDimension2Text':
      return match?.sampleDimension2Text ?? value.toString()

    case 'labRemarkText':
      return match?.labRemarkText ?? value.toString()
    case 'colorText':
      return (
        <div
          style={{
            fontWeight: 700,
            color: ['', 'var(--vbdt-color-status-success)', 'var(--vbdt-color-status-error)'][
              +value
            ],
          }}
        >
          {match?.label ?? value.toString()}
        </div>
      )

    default:
      return match?.label ?? value.toString()
  }
}

export const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e
  }
  return e?.fileList
}

export const validatorFileExtension = (fileName: string, acceptFile: string) => {
  const parts: Array<string | undefined> = fileName.split('.')
  let type: string | undefined = ''
  if (parts.length > 1) {
    type = parts.pop()
  }
  if (!!type && acceptFile.includes(type.toLowerCase())) return true
  return false
}

export async function downloadFileFromUrl(url?: string, name?: string) {
  if (!url) {
    notify.error('File không tồn tại')
    return
  }
  const token = storage.getAuthToken()
  const headers: Record<string, string> = {}
  if (token) headers.Authorization = `Bearer ${token}`
  const response = await fetch(url, { headers })
  if (!response.ok) throw new Error('Network response was not ok')

  // Tự lấy file name từ URL
  const urlParts = url.split('/')
  let fileName: any = ''
  if (name) fileName = name
  else {
    fileName = urlParts[urlParts.length - 1] || 'download'
    // Nếu URL có query string, loại bỏ nó
    fileName = fileName.split('?')[0]
  }
  const blob = await response.blob()
  const urlBlob = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = urlBlob
  a.download = fileName
  document.body.appendChild(a)
  a.click()

  a.remove()
  window.URL.revokeObjectURL(urlBlob)
}

// contact list
export const nest = (items: any[], id: any, link: string): any => {
  if (!!items && !!items?.length) {
    return items
      ?.filter((item) => item[link] === id)
      .map((item) => ({
        ...item,
        title: item.departmentName,
        label: item.departmentName,
        name: item.departmentName,
        value: item.departmentID,
        key: item.departmentID,
        children: nest(items, item?.departmentID, link),
      }))
  }
  return []
}
export function findParent({ children = [], ...object }: any, key: any) {
  let result: any
  if (object.key === key) return object
  return (
    children.some((o: any) => (result = findParent(o, key))) &&
    Object.assign({}, object, { children: [result] })
  )
}

export const treeToList = (data = []) => {
  let temVal: any[] = []
  for (const item of Object.values(data ?? {})) {
    if ((item as any).children) temVal = [...temVal, ...treeToList((item as any).children)]
    temVal = [...temVal, { ...(item as any), children: undefined }]
  }
  return temVal?.filter(
    (i) => i !== null && i !== undefined && i !== '' && !(Array.isArray(i) && i.length === 0)
  )
}
export const formatMoney = (amount: number | string) => {
  if (!amount) return '0đ'
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(Number(amount))
}
